// src/i18n/languageDetector.js
const languageDetector = {
  type: "languageDetector",
  async: true,
  init: () => {},
  detect: (callback) => {
    try {
      const saved = localStorage.getItem("i18nextLng");
      if (saved) return callback(saved);
      const nav = (navigator && (navigator.language || navigator.userLanguage)) || "en";
      const short = String(nav).split("-")[0];
      return callback(short);
    } catch (e) {
      return callback("en");
    }
  },
  cacheUserLanguage: (lng) => {
    try {
      localStorage.setItem("i18nextLng", lng);
    } catch (e) {}
  },
};

export default languageDetector;
